export interface IBillingStatementLogSearchCriteria{
    billingAccountNumbers: Array<string>;
    eventTimeFromLocal: Date;
    eventTimeToLocal:Date;
}

export class BillingStatementLogSearchCriteria implements IBillingStatementLogSearchCriteria{
    billingAccountNumbers: Array<string>;
    eventTimeFromLocal: Date;
    eventTimeToLocal:Date;
}

